import { useState } from 'react';
import { faqs, stats } from '@/mocks/home';

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            关于韩漫网站的常见疑问，这里都有答案
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mb-12">
          {stats.map((stat) => (
            <div key={stat.id} className="text-center p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/70">
              <p className="text-2xl md:text-3xl font-bold font-heading text-primary-500 mb-1">{stat.value}</p>
              <p className="text-xs md:text-sm text-foreground-500 whitespace-nowrap">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggle(faq.id)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <h4 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </h4>
                <div className={`w-5 h-5 flex items-center justify-center transition-transform duration-300 flex-shrink-0 ${openId === faq.id ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === faq.id ? 'max-h-96 pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}